import React from 'react';
import { ArrowRight } from 'lucide-react';

export default function CTASection() {
    return (
        <section className="py-32 px-6 md:px-16 bg-white flex flex-col items-center justify-center text-center relative z-20">
            <div className="max-w-3xl mx-auto flex flex-col items-center">
                <div className="inline-block px-4 py-2 font-data text-xs text-accent bg-accent/10 rounded-full uppercase tracking-widest mb-8">
                    Availability Open
                </div>

                <h2 className="font-heading text-5xl md:text-7xl font-bold tracking-tighter text-dark mb-6">
                    Ready to scale <br /> your <span className="text-drama text-accent">mobile presence?</span>
                </h2>

                <p className="font-subheading text-dark/60 text-lg max-w-xl mx-auto mb-10">
                    Book a 30-minute discovery call to discuss your Flutter app requirements, timeline, and competitive pricing options.
                </p>

                <button className="magnetic-btn bg-accent text-background px-10 py-5 rounded-full font-heading font-bold text-xl hover:bg-primary transition-colors flex items-center gap-3">
                    Book a meeting
                    <ArrowRight size={20} />
                </button>
            </div>
        </section>
    );
}
